declare let dataLayer: any;

/**
 * Google tag managerへdataLayer変数経由で値を渡す
 *
 * https://support.google.com/tagmanager/answer/6164391?hl=ja
 *
 * @param data
 */
export function pushDataLayer(data: any): void {
  // eslint-disable-next-line
  dataLayer.push;
}
